import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-16 md:py-24 px-4 bg-brand-cream" data-id="element-125">
      <div className="max-w-2xl mx-auto" data-id="element-126">
        <FadeIn data-id="element-127">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-128">
            El error de los 600 segundos
          </h2>
          <p className="text-lg mb-6 leading-relaxed" data-id="element-129">
            Muchos padres de entre 40 y 60 años en España cometen el mismo
            error: intentar "compensar" el tiempo perdido con planes grandiosos,
            regalos o preguntas constantes.
          </p>
          <p className="text-lg mb-6 leading-relaxed" data-id="element-130">
            No se dan cuenta de que el niño está viviendo un{' '}
            <strong data-id="element-131">"duelo de transición"</strong> entre dos mundos. Esa
            frialdad inicial no es falta de cariño; es un bloqueo mental por el
            cambio de casa.
          </p>
          <div className="bg-white p-6 md:p-8 rounded-lg shadow-sm border-l-4 border-brand-amber mt-8" data-id="element-132">
            <p className="text-lg leading-relaxed font-medium text-brand-brown" data-id="element-133">
              Si no sabes gestionar esos primeros 600 segundos, el resto del fin
              de semana será una batalla cuesta arriba por su atención y su
              afecto.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}